/* eslint-disable class-methods-use-this */
import SearchApi from "../API/search"
import { Service } from "./Service"

class SearchService extends Service {
    private static instance: SearchService

    constructor() {
        super()
        // set le nom du service
        this.name = "SearchService"
        // ajoute toute les methodes du service au tableau de mapping
        // this.serviceMap = []
        this.serviceMap.push({ key: "search", fct: this.searchSections })
    }

    /**
     * Récuperation de l'instance
     */
    public static getInstance(): SearchService {
        if (!this.instance) {
            this.instance = new SearchService()
        }
        return this.instance
    }

    /**
     * searchSections retourne les recherches correspondantes
     * sur les sections
     */
    public async searchSections(
        value: string,
        filter: string,
        section?: Array<string>,
        optional?: { must: Array<{ term: any }>; should: Array<{ term: any }> }
    ): Promise<any> {
        const sections = []
        const searchResult = await SearchApi.search(
            value,
            filter,
            section,
            optional
        )

        if (searchResult && searchResult.length)
            for (let index = 0; index < searchResult.length; index += 1) {
                if (section && section.length)
                    for (let j = 0; j < section.length; j += 1) {
                        if (searchResult[index].section.name === section[j]) {
                            for (
                                let k = 0;
                                k < searchResult[index].res.length;
                                k += 1
                            ) {
                                sections.push({
                                    res: searchResult[index].res[k],
                                    template: searchResult[index].templates[k],
                                    section: searchResult[index].section,
                                })
                            }
                            break
                        }
                    }
                else if (!section)
                    for (
                        let k = 0;
                        k < searchResult[index].res.length;
                        k += 1
                    ) {
                        sections.push({
                            res: searchResult[index].res[k],
                            template: searchResult[index].templates[k],
                            section: searchResult[index].section,
                        })
                    }
            }

        return Promise.resolve(sections)
    }

    /**
     * getLinks retourne toutes les actions dans le searchLink selon section
     * disponibles
     */
    public getActions(searchLinks: any, section: unknown): Array<any> {
        let links = []
        if (searchLinks?.length)
            for (let index = 0; index < searchLinks.length; index += 1) {
                if (searchLinks[index].section === section)
                    links = searchLinks[index].actions
            }

        return links
    }
}

export default SearchService
